import { Page } from '@hotjar/webapp/components/Page';
import { SharingModule } from '@hotjar/webapp/components/SharingModule';
import { SURVEY_TEMPLATES } from '@hotjar/webapp/constants/routes';
import { usePermission } from '@hotjar/webapp/domains/authorization';
import { useCurrentSite } from '@hotjar/site';
import { navigateTo } from '@hotjar/webapp/utils/routing';
import { Button, PageHeader, Tooltip } from '@hotjar/hotsauce';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

export const SurveysListHeader = (): JSX.Element => {
  const currentSite = useCurrentSite().data;

  const navigateToInAppTemplates = useCallback(() => {
    if (!currentSite) return;
    navigateTo(SURVEY_TEMPLATES.BASE.path, { siteId: currentSite.id });
  }, [currentSite]);

  const { t } = useTranslation('feedback');
  const canCreateSurvey = usePermission('surveys-create');
  return (
    <Page>
      <PageHeader
        title={t('survey-list.header.all-surveys')}
        actions={
          <>
            <SharingModule
              trigger={
                <Button size="s" kind="secondary">
                  {t('common:actions.share')}
                </Button>
              }
            />
            <Tooltip
              text={t('survey-list.table.no-create-permission')}
              isDisabled={canCreateSurvey}
            >
              <Button
                kind="primary"
                size="s"
                icon="plus"
                onClick={navigateToInAppTemplates}
                isDisabled={!canCreateSurvey}
              >
                {t('survey-list.header.new-survey')}
              </Button>
            </Tooltip>
          </>
        }
      />
    </Page>
  );
};
